<p-toast></p-toast>
<div class="card " reflow="true">
    <div class="flex flex-wrap align-items-center justify-content-center">
        <div class="field">
            <label for="name" class="mr-6">{{'APPLICATION_ID'| translate}}</label>
            <input type="text" pInputText id="name" [(ngModel)]="applicationId" required autofocus />
        </div>
    </div>    
    <div class="flex flex-wrap align-items-center justify-content-center mt-5">
        <button pButton pRipple label="{{'GET_APPLICATION_STATUS'| translate}}" class="p-button-success" (click)="getApplicationStatus()"></button>
    </div>
</div>
<router-outlet></router-outlet>
